import { router } from "expo-router";
import { useDispatch } from "react-redux";

import { setForm } from "@/context/actions/actions";
import { getUserStorage, storage } from "@/context/storage";
import { dispatchSessionExpiredAlertState } from "@/context/store";

export function getToken() {
  const token = storage.getString("user.auth.token");
  const expireIn = storage.getNumber("user.auth.expireIn");
  if (!token || Date.now() > expireIn) {
    dispatchSessionExpiredAlertState();
    router.replace("/");
    return;
  }
  return token;
}

export const checkAuthentication = () => {
  const userId = storage.getString("user.auth.userId");
  const userStorage = getUserStorage(userId);
  return userStorage.getBoolean("user.authentication");
};

export function useGetAuthentication() {
  const dispatch = useDispatch();
  const isAuthenticated = checkAuthentication();
  const expireIn = storage.getNumber("user.auth.expireIn");

  if (!isAuthenticated) {
    dispatch(setForm({ loginError: true }));
    router.push("/");
  }

  if (isAuthenticated && !storage.getString("user.auth.token")) {
    dispatch(setForm({ loginError: true }));
    router.push("/");
  }

  if (expireIn < Date.now()) {
    dispatch(setForm({ loginError: true }));
    router.push("/");
  }
}
